import styled from 'styled-components';
import IcoW01 from 'dc/IcoW01';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 32px;
`;

export const CloseIconContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  position: absolute;
  top: 0;
  width: 100%;
  background: transparent;
  &:hover > i {
    color: #0099a9;
  }
`;

export const CloseIcon = styled(IcoW01)`
  cursor: pointer;
  color: #607d8b;
`;
